import { MediaConnectionEventNames, RoapMediaConnection, } from '@webex/internal-media-core';
import { CALL_UTILS_FILE, ICE_CANDIDATES_TIMEOUT } from '../CallingClient/constants';
import log from '../Logger';
import { CANDIDATE_ADDRESS_INDEX, EXCLUDED_HOST_IPS, IPV4_FALLBACK_ADDRESS, MAX_HOST_IPS, SDP_HOST_CANDIDATE_REGEX, } from './constants';
let hostIps = [];
export function modifySdpForIPv4(sdp) {
    try {
        sdp = sdp.replace(/\r\n|\r/g, '\n');
        sdp = sdp.replace(/^[ \t]+/gm, '');
        const ipv6CLineMatches = sdp.match(/c=IN IP6 [\da-f:.]+/gi) || [];
        const hasIPv6CLine = ipv6CLineMatches.length > 0;
        if (hasIPv6CLine) {
            log.info('Modifying SDP for IPv4 compatibility', {
                file: CALL_UTILS_FILE,
                method: 'modifySdpForIPv4',
            });
            const ipv4CandidateMatch = sdp.match(/a=candidate:\d+ \d+ \w+ \d+ ([\d.]+) \d+ typ \w+/);
            const ipv4Address = ipv4CandidateMatch?.[1] || IPV4_FALLBACK_ADDRESS;
            sdp = sdp.replace(/c=IN IP6 [\da-f:.]+/gi, `c=IN IP4 ${ipv4Address}`);
            if (!ipv4CandidateMatch) {
                let ipv4CandidateAdded = false;
                sdp = sdp.replace(/(a=candidate:(\d+) (\d+) (\w+) (\d+) ([\da-f:.]+) (\d+) typ (\w+)[^\n]*)/g, (match, full, foundation, componentId, transport, priority, connectionAddress, port, candidateType) => {
                    if (!ipv4CandidateAdded && connectionAddress.includes(':')) {
                        ipv4CandidateAdded = true;
                        const newFoundation = (parseInt(foundation, 10) + 1).toString();
                        return (`${full}\n` +
                            `a=candidate:${newFoundation} ${componentId} ${transport} ${priority} ${ipv4Address} ${port} typ ${candidateType} generation 0 network-id 1 network-cost 10`);
                    }
                    return match;
                });
            }
        }
        return sdp;
    }
    catch (error) {
        log.warn(`Error modifying SDP for IPv4 compatibility: ${error}`, {
            file: CALL_UTILS_FILE,
            method: 'modifySdpForIPv4',
        });
        return sdp;
    }
}
export function getHostIps() {
    return hostIps;
}
export function getHostIpsFromSdp(sdp) {
    const candidates = sdp?.match(SDP_HOST_CANDIDATE_REGEX) || [];
    return candidates
        .map((candidate) => candidate.split(' ')[CANDIDATE_ADDRESS_INDEX])
        .filter((address, index, addresses) => !EXCLUDED_HOST_IPS.includes(address) && addresses.indexOf(address) === index)
        .slice(0, MAX_HOST_IPS);
}
export async function discoverHostIps(localAudioStream) {
    const logContext = { file: CALL_UTILS_FILE, method: 'discoverHostIps' };
    let connection;
    hostIps = [];
    try {
        connection = new RoapMediaConnection({
            skipInactiveTransceivers: true,
            iceServers: [],
            iceCandidatesTimeout: ICE_CANDIDATES_TIMEOUT,
            sdpMunging: {
                convertPort9to0: true,
                addContentSlides: false,
                copyClineToSessionLevel: true,
            },
        }, {
            localTracks: { audio: localAudioStream.outputStream.getAudioTracks()[0] },
            direction: {
                audio: 'sendrecv',
                video: 'inactive',
                screenShareVideo: 'inactive',
            },
        }, 'WebexCallSDK-hostIpDiscovery');
        connection.on(MediaConnectionEventNames.ROAP_MESSAGE_TO_SEND, (event) => {
            if (event.roapMessage.messageType === 'OFFER') {
                hostIps = getHostIpsFromSdp(event.roapMessage.sdp);
            }
        });
        await connection.initiateOffer();
        log.info(`Discovered ${hostIps.length} host ip(s)`, logContext);
    }
    catch (error) {
        hostIps = [];
        log.warn(`Host ip discovery failed: ${error}`, logContext);
    }
    finally {
        connection?.close();
    }
}
